import React, { useEffect, useState, useRef } from "react"
import { graphql } from "gatsby"
import Flink from '~/components/shared/flink'
import { useTheme } from '~/contexts/ThemeContext'
import { Seo } from '~/components/shared/seo'
import { imgSize } from '~/utils/helpers'

import { field, field_submit, solid_btn, label_small } from "~/styles/app.module.scss"
import * as styles from "~/styles/pages/giftcard_balance.module.scss"

const GiftCardBalance = ({ data: { gift } }) => {
  const { isMobile } = useTheme()

  const page = gift.data
  const inptRef = useRef(null)

  const [isLoad, setIsLoad] = useState(false)
  const [result, setResult] = useState(false)
  const [resultStatus, setResultStatus] = useState(false)
  const [focus, setFocus] = useState(false)

  const handleKey = (e) => {
    if ( e.key === 'Enter' ) handleSubmit()
    if ( e.target.value === '' ) setResult(false)
  }

  const handleSubmit = () => {
    curr_balance()
  }

  const curr_balance = async () => {
    const code = inptRef.current.value

    fetch('https://pima.io/api/check-gift-card', {
      method: "POST",
      body: JSON.stringify({code: code}),
      headers: {
        "Content-Type": "application/json",
      }
    })
    .then(async(response) => {
      setResult(true)
      if (response.ok) {
        const result = await response.json()
        setResultStatus(result)
      }
      else {
        throw new Error(response.status + " Failed Fetch ")
      }
    }).catch(e => setResultStatus('error'))
  }

  useEffect(() => {
    setIsLoad(isMobile ? imgSize(page.image,900) : imgSize(page.image,1100) )

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  return (
    <section className={styles.gift_balance}>
      <div className={styles.contain}>

        <div className={styles.image}>
          {isLoad && (
            <img className={styles.img} src={isLoad} alt="View of a Buck Mason gift card" />
          )}
        </div>

        <div className={styles.content}>
          <h1 className={styles.title}>
            <div className={styles.copy} aria-hidden={result ? 'true' : 'false'}>
              {page.title}
            </div>
            <div className={styles.result} aria-hidden={result ? 'false' : 'true'}>
              {resultStatus !== 'error' ? (
                <>
                  Your balance is 
                  <span className={styles.dollars}> ${resultStatus}</span>
                </>
              ) : (
                <>
                  GIFT CARD NOT FOUND
                </>
              )}
            </div>
          </h1>

          <div className={styles.form}>
            <div id="j_gift_balance-form">
              <div className={field}>
                <label htmlFor="j_gift_balance-number" className={label_small} aria-hidden={focus ? 'false' : 'true'}>
                  Gift Card Number
                </label>
                <input 
                  type="text" 
                  id="j_gift_balance-number" 
                  placeholder="Gift Card Number" 
                  required 
                  aria-required="true" 
                  aria-label="Gift Card Number" 
                  ref={inptRef}
                  onInput={(e) => {setFocus(true); if (e.target.value === '') setResult(false) }}
                  onBlur={(e) => {setFocus(false)}}
                  onKeyDown={(e) => handleKey(e)}
                />
              </div>
              <div className={field_submit}>
                <input 
                  type="submit" 
                  className={solid_btn} 
                  value="Check Balance" 
                  onClick={(e)=> handleSubmit()}
                />
              </div>
            </div>
            
            <p>Questions? <Flink title="FAQ" href="/pages/faq">Contact Us</Flink></p>
          </div>
        </div>
      </div>
    </section>
  )
}
export default GiftCardBalance


export const Head = ({ data: { gift } }) => (
  <Seo 
    title={'Gift Card Balance'}
    description={`Check the balance on your Buck Mason gift card`}
    image={gift.data.metaimg}
    url={`/pages/gift-card-balance`}
  />
)



export const pageQuery = graphql`
  {
    gift: contentPage(type: {eq: "GiftCardBalance"}) {
      data
    }
  }
`;

